import Immutable from 'seamless-immutable';
import {
  SAVE_CYLINDERS,
  SET_SELECTED_CYLINDER,
  SAVE_KEYS,
  SET_SELECTED_KEY,
  SAVE_RELATIONS,
  RESET_MKS_DATA,
  SAVE_MKS_REQUESTS,
  SET_SELECTED_MKS_REQUEST,
  SAVE_MKS_REQUEST_DETAIL,
  UPDATE_MKS_REQUEST,
  DELETE_MKS_REQUEST,
  CHANGE_MKS_REQUEST_STATUS,
  EXPORT_MKS_REQUESTS,
  RESET_MKS_REQUESTS_DATA,
  RESET_MKS_CYLINDERS_DATA,
  RESET_MKS_KEYS_DATA,
  RESET_MKS_RELATIONS_DATA,
  SET_MKS_FILTER,
  RESET_MKS_FILTER,
} from '../actions/actionTypes/mks';

const initialState = Immutable({
  cylinders: {
    data: {},
    selectedCylinder: {},
  },
  keys: {
    data: {},
    selectedKey: {},
  },
  relations: {
    data: {},
  },
  mksRequests: {
    data: {},
    selectedRequest: {},
    requestDetail: {},
    exportedRequests: [],
    filters: {},
  },
});

export default function (state = initialState, action) {
  switch (action.type) {
    case SAVE_CYLINDERS:
      return state.setIn(['cylinders', 'data'], action.cylinders);
    case SET_SELECTED_CYLINDER:
      return state.setIn(['cylinders', 'selectedCylinder'], action.cylinder);
    case SAVE_KEYS:
      return state.setIn(['keys', 'data'], action.keys);
    case SET_SELECTED_KEY:
      return state.setIn(['keys', 'selectedKey'], action.key);
    case SAVE_RELATIONS:
      return state.setIn(['relations', 'data'], action.relations);
    case RESET_MKS_DATA:
      return state
        .setIn(['cylinders', 'data'], {})
        .setIn(['cylinders', 'selectedCylinder'], {})
        .setIn(['keys', 'data'], {})
        .setIn(['keys', 'selectedKey'], {})
        .setIn(['relations', 'data'], {});
    case SAVE_MKS_REQUESTS:
      return state.setIn(['mksRequests', 'data'], action.requests);
    case SET_SELECTED_MKS_REQUEST:
      return state.setIn(['mksRequests', 'selectedRequest'], action.request);
    case SAVE_MKS_REQUEST_DETAIL:
      return state.setIn(['mksRequests', 'requestDetail'], action.requestDetail);
    case UPDATE_MKS_REQUEST:
      return state.setIn(['mksRequests', 'requestDetail'], action.request);
    case DELETE_MKS_REQUEST:
      return state.setIn(['mksRequests', 'requestDetail'], action.request);
    case EXPORT_MKS_REQUESTS:
      return state.setIn(['mksRequests', 'exportedRequests'], action.requests);
    case RESET_MKS_REQUESTS_DATA:
      return state
        .setIn(['mksRequests', 'data'], {})
        .setIn(['mksRequests', 'selectedRequest'], {})
        .setIn(['mksRequests', 'requestDetail'], {})
        .setIn(['mksRequests', 'exportedRequests'], []);
    case RESET_MKS_CYLINDERS_DATA:
      return state.setIn(['cylinders', 'data'], {});
    case RESET_MKS_KEYS_DATA:
      return state.setIn(['keys', 'data'], {});
    case RESET_MKS_RELATIONS_DATA:
      return state.setIn(['relations', 'data'], {});
    case SET_MKS_FILTER:
      return state.setIn(['mksRequests', 'filters', action.filterKey], action.filterValue);
    case RESET_MKS_FILTER:
      return state.setIn(['mksRequests', 'filters'], {});
    default:
      return state;
  }
}
